export default __webpack_public_path__ + "07793e547c02e40dc357fbc663717f5d.png";